module.exports = "<div class=\"office-licensure-container\">\n    <div class=\"row office-licensure-header-container\">\n        <div class=\"col-md-12\">\n            <h2>Licensure</h2>\n        </div>\n    </div>\n    <ng-include src=\"'app/accounts/offices/licensure/viewLicensure.html'\"></ng-include> \n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/offices/licensure/officeLicensure.html
// module id = 475
// module chunks = 1